import {PlanStore} from "../../stores/subscription-plans-store";
import {observer} from "mobx-react-lite";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR} from "../../../../components/fonts/font-props";
import './installments-view.scss';


interface IInstallmentsView {
    plan: PlanStore
}

const InstallmentsView: React.FC<IInstallmentsView> = observer(({plan}: IInstallmentsView) => {
    if(!plan.hasInstallments()) {
        return null;
    }

    return <div className="installments-view-wrapper">
        <FontBody2 color={FONT_COLOR.NEUTRAL3}>
            {`Paid in ${plan.parentPlan?.installments?.length} installments`}
        </FontBody2>
    </div>;
});

export default InstallmentsView;